<template lang="pug">

include ../../../pug/mixins/index

+b.slider-wrapper
  +e.child.img(v-if='order == 0'): img(src="/static/images/child.png")
  +e.numeric: +b.numeric
    +e.UL.list
      //- +e.LI.item: +e.A.link.center(href="#", @click.prevent='') 0
      +e.LI.item(v-for='stage in stages')
        +e.A.link.center(
          href="#",
          :class='stageSelectorClass(stage)',
          v-text='stage.order',
          @click.prevent='order = stage.order'
        )
  +e.SLIDER.slider.--mobile(:options!=`{
    slidesPerView: 1,
    pagination : '.slider-wrapper__dots',
    autoplay: 4000,
    autoplayDisableOnInteraction: true,
  }`, v-if='isMobile', ref='slider')
    +b.SWIPER-SLIDE.slider(
      v-for='slide in stage.slides',
      :key='slide.id',
      :style=`{
        'background-image': 'url('+ (slide.mobile_image || slide.image) +')',
      }`
    )
      .container
        +e.wrap
          +e.slider
            +e.block
              +e.unit
                +e.H2.title(v-text='slide.title')
                +e.text(v-text='slide.text')
    +e.dots(slot='pagination')
  +e.SLIDER.slider.--desktop(:options!=`{
    slidesPerView: 1,
    pagination : '.slider-wrapper__dots',
    autoplay: 4000,
    autoplayDisableOnInteraction: true,
  }`, v-else='', ref='slider')
    +b.SWIPER-SLIDE.slider(
      v-for='slide in stage.slides',
      :key='slide.id',
      :style=`{
        'background-image': 'url('+ slide.image +')',
      }`
    )
      .container
        +e.wrap
          +e.slider
            +e.block
              +e.unit
                +e.H2.title(v-text='slide.title')
                +e.text(v-text='slide.text')
    +e.dots(slot='pagination')

</template>

<script>

import querystring from 'querystring'

import Translatable from '@shared/mixins/translatable'

export default {
  props: {
    stages: { type: Array },
  },

  data() {
    let order = this.stages[0].order
    let query = querystring.parse(window.location.search.substr(1))
    if (query.slider) {
      order = parseInt(query.slider)
    }

    return {
      order,
      isMobile: false
    }
  },

  mixins: [Translatable],

  mounted() {
    let $w =  $(window)
    const resizer = e => {
      this.isMobile = $w.outerWidth() < 961
    }
    $w.resize(resizer)
    resizer()
  },

  watch: {
    order(nval, oval) {
      if (nval != oval) {
        this.$refs.slider.update()
        this.$refs.slider.$refs.swiper.swiper.slideTo(0)
      }
    }
  },

  computed: {
    stage() {
      return this.stages.find(x => x.order == this.order)
    }
  },

  methods: {
    stageSelectorClass(stage) {
      return {
        [`numeric__link--${stage.order}`]: true,
        'is-active': stage.order == this.order
      }
    },

    sortProducts(oproducts) {
      return products.sort((a, b) => a.order - b.order)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/js/calendar/components/slider.vue